import { FuseAnimate } from "@fuse";
import _ from "@lodash";
import { Radio, withStyles } from "@material-ui/core";
import PaginadorApp from "app/Core/Components/Paginador/PaginadorApp";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import * as AppActions from "app/store/actions";
import classNames from "classnames";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import ReactTable from "react-table";
import { bindActionCreators } from "redux";
import * as Actions from "./Store/Actions/EmpresaFormaPagamentoActions";

const styles = theme => ({
    root: {
        color: theme.palette.text.primary,
    }
});

class EmpresaFormaPagamentoList extends XAPPComponent {

    state = {
        selected: []
    };

    componentDidMount() {
        const { listFilter } = this.props;
        listFilter(null, "spvwempresaformapagamento");
    }

    componentDidUpdate() {
        if (this.props.FormaPagamento.error) {
            this.props.showMessage({
                message: this.props.FormaPagamento.error,
                variant: "error"
            });
            this.props.FormaPagamento.error = null;
        }
    }

    handleChangeRadio = (event, item) => {
        var AState = this.state.selected;
        var AExists = false;
        if (this.isSelected(item.idpessoaformulario))
            AExists = true;

        if (!AExists) {
            var obj = item;
            obj["id"] = item.idpessoaformulario;
            obj["label"] = item.nome;
            if (!this.props.multiSelect)
                AState = [];
            AState.push(obj);
            this.setState(_.set({ ...this.state }, event.target.name, AState));
            this.props.onChange(AState);
        }
    };

    isSelected = (id) => {
        var AState = this.state.selected;
        var AExists = false;
        AState.forEach((item) => {
            if (item.idpessoaformulario === id || item.id === id)
                AExists = true;
        });
        return AExists;
    };

    getColumns = (_AisLookup) => {
        const { isLookup } = this.props;
        const { selected } = this.state;
        const Columns = [
            {
                Header: "",
                width: 60,
                Cell: row => (
                    <div className="flex items-center">
                        {isLookup && row.original.statusregistro === 1 && (
                            <Radio
                                name="selected"
                                checked={selected?.length > 0 && this.isSelected(row.original.idpessoaformulario)}
                                onClick={event => event.stopPropagation()}
                                onChange={event => this.handleChangeRadio(event, row.original)}
                            />
                        )}
                    </div>
                )
            },
            {
                Header: "Nome",
                accessor: "nome",
                className: ""
            },
            {
                Header: "Padrão",
                className: "justify-center",
                Cell: row => (
                    <span>{row.original.formulario.default === 1 ? "Sim" : "Não"}</span>
                )
            }
        ];

        if (_AisLookup !== true) {
            Columns.splice(0, 1);
        }
        return Columns;
    };

    nextPage = () => {
        const { filter, xappRouteParams, FormaPagamento } = this.props;
        if (FormaPagamento.pagina < FormaPagamento.data[0].paginas) {
            this.props.list("SELECIONAR", xappRouteParams, filter, FormaPagamento.pagina + 1);
        }
    };

    render() {
        const { FormaPagamento, openEditDialog, classes, isLookup } = this.props;

        return (
            <React.Fragment>
                <FuseAnimate animation="transition.slideUpIn" delay={300}>
                    <ReactTable
                        className={classNames(classes.root, "-striped -highlight border-0")}
                        getTrProps={(state, rowInfo) => {
                            return {
                                className: !_.isUndefined(rowInfo) && !_.isNull(rowInfo.original.idpessoa) && "cursor-pointer",
                                onClick: () => {
                                    if (!_.isUndefined(rowInfo) && !_.isNull(rowInfo.original.idpessoa)) {
                                        openEditDialog(rowInfo.original);
                                    }
                                }
                            };
                        }}
                        data={FormaPagamento.data ? FormaPagamento.data : []}
                        columns={this.getColumns(isLookup)}
                        defaultPageSize={100}
                        noDataText="Não existem registros cadastrados!"
                        PaginationComponent={PaginadorApp}
                        nextPage={this.nextPage}
                        paginas={FormaPagamento.data ? FormaPagamento.data[0].paginas : 1}
                        pagina={FormaPagamento.pagina}
                    />
                </FuseAnimate>
            </React.Fragment>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        list: Actions.list,
        openNewDialog: Actions.openNewDialog,
        openEditDialog: Actions.openEditDialog,
        showMessage: AppActions.showMessage,
    }, dispatch);
}

function mapStateToProps({ EmpresaFormaPagamento }) {
    return {
        FormaPagamento: EmpresaFormaPagamento
    };
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(EmpresaFormaPagamentoList)));
